// Должен соответствовать projectName
/* istanbul ignore next */
export const UNIQUE_CONFIG_KEY = 'countryside-project-card-frontend';

export const DEFAULT_API_TIMEOUT = 2000;
export const BUILDING_ORDER_API_TIMEOUT = 4000;
